/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListPoolsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {ListPoolsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const listPools = (request: ListPoolsRequest, options?: CashRequestOptions) => post<ListPoolsRequest, ListPoolsResponse>("/2.0/cash/list-pools", request, {...options, rejectOnError: true })